/* SquishCosmia theme — drawers, cart AJAX, variants, accordions */
(function(){
  const $  = (s,r=document)=>r.querySelector(s);
  const $$ = (s,r=document)=>Array.from(r.querySelectorAll(s));
  let lastFocus=null, toastTimer;

  function toast(msg){
    const t=$('#toast'); if(!t) return;
    t.textContent=msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer=setTimeout(()=>t.classList.remove('show'),2800);
  }
  function openDrawer(id){
    const d=$(id); if(!d) return;
    lastFocus=document.activeElement;
    d.classList.add('open'); d.setAttribute('aria-hidden','false');
    $('#scrim').classList.add('open');
    document.body.classList.add('is-locked');
    const f=d.querySelector('button,a,input'); if(f) f.focus();
  }
  function closeDrawers(){
    $$('.drawer').forEach(d=>{d.classList.remove('open');d.setAttribute('aria-hidden','true');});
    const s=$('#scrim'); if(s) s.classList.remove('open');
    document.body.classList.remove('is-locked');
    const nt=$('#navToggle'); if(nt) nt.setAttribute('aria-expanded','false');
    if(lastFocus){ try{lastFocus.focus();}catch(e){} lastFocus=null; }
  }

  /* ---------- cart ---------- */
  async function refreshCart(open){
    try{
      const res=await fetch(window.routes.cart_url+'?section_id=cart-drawer');
      const html=await res.text();
      const doc=new DOMParser().parseFromString(html,'text/html');
      const fresh=doc.querySelector('#cartDrawerInner');
      if(fresh) $('#cartDrawerInner').innerHTML=fresh.innerHTML;
      const c=await (await fetch(window.routes.cart_url+'.js')).json();
      const badge=$('#cartCount');
      if(badge){ badge.textContent=c.item_count; badge.hidden=c.item_count===0; }
      if(open) openDrawer('#cartDrawer');
    }catch(e){ console.error(e); }
  }
  async function addToCart(id,qty,btn){
    if(btn) btn.classList.add('is-loading');
    try{
      const r=await fetch(window.routes.cart_add_url+'.js',{
        method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:Number(id),quantity:Number(qty)||1}]})
      });
      const data=await r.json();
      if(!r.ok){ toast(data.description||'That item could not be added'); return; }
      await refreshCart(true);
      toast('Added to cart');
    }catch(e){ toast('Something went wrong — try again'); }
    finally{ if(btn) btn.classList.remove('is-loading'); }
  }
  async function changeLine(key,qty){
    await fetch(window.routes.cart_change_url+'.js',{
      method:'POST', headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})
    });
    await refreshCart(false);
    if(document.body.classList.contains('template-cart')) location.reload();
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click',e=>{
    const t=e.target;
    if(t.closest('[data-drawer-close]')||t.closest('#scrim')) return closeDrawers();
    if(t.closest('#navToggle')){ openDrawer('#navDrawer'); $('#navToggle').setAttribute('aria-expanded','true'); return; }
    if(t.closest('#cartToggle')){ e.preventDefault(); return openDrawer('#cartDrawer'); }

    const st=t.closest('#searchToggle');
    if(st){ const w=$('#searchWrap'); const o=w.classList.toggle('open');
      st.setAttribute('aria-expanded',String(o)); if(o) $('#searchInput').focus(); return; }

    const qa=t.closest('[data-quick-add]');
    if(qa){ e.preventDefault(); return addToCart(qa.dataset.quickAdd,1,qa); }

    const line=t.closest('[data-line-change]');
    if(line){ e.preventDefault(); return changeLine(line.dataset.key,Number(line.dataset.qty)); }

    const q=t.closest('[data-qty-step]');
    if(q){
      const box=q.closest('.qty'), input=box.querySelector('input');
      const v=Math.max(1,(parseInt(input.value,10)||1)+Number(q.dataset.qtyStep));
      input.value=v; input.dispatchEvent(new Event('change',{bubbles:true}));
      const sticky=$('#stickyQty'); if(sticky) sticky.value=v;
      return;
    }

    const acc=t.closest('.acc__btn');
    if(acc){
      const open=acc.getAttribute('aria-expanded')==='true';
      acc.setAttribute('aria-expanded',String(!open));
      const p=document.getElementById(acc.getAttribute('aria-controls'));
      if(p) p.classList.toggle('open',!open);
      return;
    }

    const th=t.closest('[data-media-index]');
    if(th){
      const i=th.dataset.mediaIndex;
      $$('[data-media-slide]').forEach(s=>s.hidden=s.dataset.mediaSlide!==i);
      $$('[data-media-index]').forEach(b=>b.setAttribute('aria-pressed',String(b===th)));
      return;
    }

    const opt=t.closest('[data-opt]');
    if(opt){ selectOption(opt); return; }

    const fav=t.closest('[data-fav]');
    if(fav){ const on=fav.getAttribute('aria-pressed')==='true';
      fav.setAttribute('aria-pressed',String(!on)); toast(on?'Removed from favourites':'Saved to favourites'); return; }

    const sticky=t.closest('#stickyAdd');
    if(sticky){ e.preventDefault(); const f=$('#ProductForm'); if(f) f.requestSubmit(); }
  });

  document.addEventListener('keydown',e=>{ if(e.key==='Escape') closeDrawers(); });

  /* ---------- variant picker ---------- */
  function selectOption(btn){
    const group=btn.dataset.opt;
    $$('[data-opt="'+group+'"]').forEach(b=>b.setAttribute('aria-pressed',String(b===btn)));
    const label=$('#optLabel-'+group); if(label) label.textContent=btn.dataset.value;
    updateVariant();
  }
  function updateVariant(){
    const data=$('#VariantData'); if(!data) return;
    const variants=JSON.parse(data.textContent);
    const chosen=$$('[data-opt][aria-pressed="true"]').map(b=>b.dataset.value);
    const match=variants.find(v=>v.options.every((o,i)=>o===chosen[i]));
    const idInput=$('#VariantId'), price=$('#pdpPrice'), addBtn=$('#AddBtn'), sPrice=$('#stickyPrice');
    if(!match){
      if(addBtn){ addBtn.disabled=true; addBtn.textContent='Unavailable'; }
      return;
    }
    if(idInput) idInput.value=match.id;
    if(price) price.innerHTML=match.price_html;
    if(sPrice) sPrice.innerHTML=match.price_html;
    if(addBtn){ addBtn.disabled=!match.available; addBtn.textContent=match.available?'Add to cart':'Sold out'; }
    if(match.featured_media_index!==null && match.featured_media_index!==undefined){
      const th=document.querySelector('[data-media-index="'+match.featured_media_index+'"]');
      if(th) th.click();
    }
    const url=new URL(location);
    url.searchParams.set('variant',match.id);
    history.replaceState({},'',url);
  }

  /* ---------- product form ---------- */
  document.addEventListener('submit',e=>{
    const f=e.target;
    if(f.id==='ProductForm'){
      e.preventDefault();
      const id=f.querySelector('#VariantId').value;
      const qty=f.querySelector('[name="quantity"]') ? f.querySelector('[name="quantity"]').value : 1;
      addToCart(id,qty,f.querySelector('#AddBtn'));
    }
  });

  document.addEventListener('change',e=>{
    if(e.target.matches('[data-line-qty]')){
      changeLine(e.target.dataset.key,Math.max(0,parseInt(e.target.value,10)||0));
    }
    if(e.target.id==='sortSelect'){
      const u=new URL(location); u.searchParams.set('sort_by',e.target.value); u.searchParams.delete('page'); location=u;
    }
  });

  document.addEventListener('DOMContentLoaded',()=>{
    if($('#VariantData')) updateVariant();
    const y=$('#year'); if(y) y.textContent=new Date().getFullYear();
  });
  window.SquishCosmia={toast,openDrawer,closeDrawers,refreshCart};
})();
